import React from 'react';
import ExercisePracticeLayout from '../components/exercise/ExercisePracticeLayout';
import type { RouteObject } from 'react-router-dom';
import {
  MyClassrooms,
  PublicResources,
  StudentAssignmentDetail,
  StudentClassroomDetail,
  StudentMultiChoicePractice,
  StudentSubmission,
  WorksheetAttemptPage,
  WorksheetAttemptReviewPage,
} from './lazyPages';

export const sharedMemberRoutes: RouteObject[] = [
  {
    path: 'my-classrooms',
    element: (
      <React.Suspense fallback={null}>
        <MyClassrooms />
      </React.Suspense>
    ),
  },
  {
    path: 'public-resources',
    element: (
      <React.Suspense fallback={null}>
        <PublicResources />
      </React.Suspense>
    ),
  },
];

export const studentRoutes: RouteObject[] = [
  {
    path: 'my-classrooms/:code',
    element: (
      <React.Suspense fallback={null}>
        <StudentClassroomDetail />
      </React.Suspense>
    ),
  },
  {
    path: 'student/assignments/:code',
    element: (
      <React.Suspense fallback={null}>
        <StudentAssignmentDetail />
      </React.Suspense>
    ),
  },
  {
    path: 'student/assignments/:code/practice',
    element: (
      <React.Suspense fallback={null}>
        <ExercisePracticeLayout>
          <StudentMultiChoicePractice />
        </ExercisePracticeLayout>
      </React.Suspense>
    ),
  },
  {
    path: 'student/assignments/:code/worksheet',
    element: (
      <React.Suspense fallback={null}>
        <WorksheetAttemptPage />
      </React.Suspense>
    ),
  },
  {
    path: 'student/assignments/:code/worksheet/submissions/:submissionId',
    element: (
      <React.Suspense fallback={null}>
        <WorksheetAttemptReviewPage />
      </React.Suspense>
    ),
  },
  {
    path: 'student/assignments/:code/submission',
    element: (
      <React.Suspense fallback={null}>
        <StudentSubmission />
      </React.Suspense>
    ),
  },
];
